import React, { useEffect, useMemo, useState } from "react";
import {
  CommonInput,
  CommonModal,
  CustomSelect,
  GoogleCitySearch,
} from "components";
import { Images } from "constants";
import { addUserProfile, uploadFile } from "_services/userService";
import { FaPencil } from "react-icons/fa6";
import toast from "react-hot-toast";

const AddUserProfile = ({ props: modalProps }) => {
  const obj = {
    firstName: "",
    lastName: "",
    email: "",
    userProfileImageUrl: "",
    phoneNumber: "",
    countryCode: "+91",
    generationId: "",
    city: "",
    state: "",
    country: "",
  };
  const [formData, setFormData] = useState(obj);
  const [birdStatusList, setBirdStatusList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [formError, setFormError] = useState({});
  const [locationData, setLocationData] = useState(null);
  const [nearbyPlaces, setNearbyPlaces] = useState([]);

  const getMasterData = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("masterData"));
    } catch {
      return null;
    }
  }, []);

  useEffect(() => {
    const birds = getMasterData?.userGenerations;

    if (Array.isArray(birds) && birds.length) {
      const birdList = birds.map((i) => ({
        label: i?.title,
        value: i?._id,
      }));
      setBirdStatusList([...birdList]);
    }
  }, [getMasterData]);

  useEffect(() => {
    if (locationData) {
      setFormData((prev) => ({
        ...prev,
        city: locationData.city || "",
        state: locationData.state || "",
        country: locationData.country || "",
      }));
    }
  }, [locationData]);

  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    const errors = {};
    if (!formData.firstName.trim()) errors.firstName = "First name is required";
    if (!formData.lastName.trim()) errors.lastName = "Last name is required";
    if (!formData.email.trim()) errors.email = "Email is required";
    if (!formData.phoneNumber.trim()) {
      errors.phoneNumber = "Mobile is required";
    } else if (!/^\d{10}$/.test(formData.phoneNumber.trim())) {
      errors.phoneNumber = "Mobile number must be 10 digits";
    }
    if (!formData.generationId.trim())
      errors.generationId = "Generation is required";
    if (!formData.userProfileImageUrl.trim())
      errors.userProfileImageUrl = "Image is required";
    if (!formData.city.trim()) errors.city = "City is required";
    return errors;
  };

  const handleFileUpload = async (e) => {
    try {
      const file = e.target.files[0];
      if (!file) return;
      const response = await uploadFile(file);
      if (response?.data?.file?.fullUrl) {
        setFormData((prev) => ({
          ...prev,
          userProfileImageUrl: response?.data?.file?.fullUrl,
        }));
      }
    } catch (err) {
      console.error("Upload failed:", err);
    }
  };

  const handleSubmit = async () => {
    const errors = validate();
    if (Object.keys(errors).length) {
      setFormError(errors);
      setMessage("Image is required");
      return;
    }

    setLoading(true);
    setFormError({});
    setMessage("");

    try {
      const payload = {
        ...formData,
      };
      const response = await addUserProfile(payload);
      modalProps?.closeModal();

      const successMessage = response?.message || "User updated successfully!";
      toast.success(successMessage);

      if (modalProps.onSuccess) {
        modalProps.onSuccess();
      }
    } catch (err) {
      toast.error(err);
    } finally {
      setLoading(false);
    }
  };

  const modalConfig = {
    ...modalProps,
    onSubmit: handleSubmit,
    // submitLoading: loading,
    // submitTitle: 'Update User',
  };

  return (
    <CommonModal {...modalConfig}>
      <div className="addLr_body">
        <div className="_allDflx flex flex-col gap-4">
          <div>
            <div className="__profilPic_bx ">
              <img
                src={formData.userProfileImageUrl || Images.USERLIMG}
                alt="User Profile"
                className=""
              />
              <button
                type="button"
                className="__profilPic_edit "
                onClick={() => document.getElementById("fileInput").click()}
              >
                <FaPencil />
              </button>
              <input
                style={{ display: "none" }}
                type="file"
                id="fileInput"
                accept="image/*"
                className="hidden"
                onChange={handleFileUpload}
                focus={!!formError.userProfileImageUrl}
                error={formError.userProfileImageUrl}
              />
            </div>
            {message && (
              <p
                className="text-center text-green-600 mt-1"
                style={{
                  color: "var(--invailid-color)",
                  fontSize: "13px",
                  fontWeight: 500,
                }}
              >
                {message}
              </p>
            )}
          </div>

          <CommonInput
            type="text"
            label="First Name *"
            placeholder="Enter First Name"
            name="firstName"
            value={formData.firstName}
            onChange={({ target: { name, value } }) =>
              handleChange(name, value)
            }
            focus={!!formError.firstName}
            error={formError.firstName}
          />

          <CommonInput
            type="text"
            label="Last Name *"
            placeholder="Enter Last Name"
            name="lastName"
            value={formData.lastName}
            onChange={({ target: { name, value } }) =>
              handleChange(name, value)
            }
            focus={!!formError.lastName}
            error={formError.lastName}
          />

          <CommonInput
            type="email"
            label="Email *"
            placeholder="Enter Email"
            name="email"
            value={formData.email}
            onChange={({ target: { name, value } }) =>
              handleChange(name, value)
            }
            focus={!!formError.email}
            error={formError.email}
          />

          <CommonInput
            type="number"
            label="Mobile Number*"
            placeholder="Enter Mobile Number"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={({ target: { name, value } }) =>
              handleChange(name, value)
            }
            focus={!!formError.phoneNumber}
            error={formError.phoneNumber}
          />

          <CustomSelect
            options={birdStatusList}
            value={birdStatusList.find(
              (i) => i.value === formData?.generationId
            )}
            name="generationId"
            label="Select Generation"
            placeholder="Select Generation"
            onSelect={(data) => handleChange("generationId", data?.value)}
            focus={!!formError.generationId}
            error={formError.generationId}
          />

          <GoogleCitySearch
            apiKey={process.env.NEXT_PUBLIC_GOOGLE_API_KEY}
            onAddressChange={setLocationData}
            onNearbyResults={setNearbyPlaces}
            placeholder="Select Location"
            error={formError.city}
          />
        </div>
      </div>
    </CommonModal>
  );
};

export default AddUserProfile;
